import styled from '@emotion/styled';

interface IProps {
	hasValue: boolean;
}

export const DropdownContainer = styled.div`
	position: relative;
	min-width: 10rem;
	height: 4.4rem;
	width: auto;
`;

export const SelectBox = styled.div<{ isOpen: boolean }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.8rem;
	height: 100%;
	padding: 8px 12px;
	border: 1px solid #adb5bd;
	border-color: ${(props) => (props.isOpen ? `#12539E` : `#adb5bd`)};
	border-radius: ${(props) =>
		props.isOpen
			? `${props.theme.borderRadius.control} ${props.theme.borderRadius.control} 0 0`
			: props.theme.borderRadius.control};
	background-color: white;
	cursor: pointer;
`;

export const SelectedText = styled.span<IProps>`
	color: ${(props) => (props.hasValue ? `#212529` : `#868e96`)};
	font-size: 14px;
	white-space: nowrap;
`;

// Replaced the ArrowIcon with your desired arrow
export const ArrowIcon = styled.span<{ isOpen: boolean }>`
	display: inline-block;
	transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
	transition: transform 0.2s ease;
	font-size: 12px;
`;

export const OptionsList = styled.ul<{ isOpen: boolean }>`
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	margin: 0;
	padding: 0;
	list-style: none;
	border: 1px solid #ccc;
	border-top: none;
	border-radius: 0 0 ${(props) => props.theme.borderRadius.control} ${(props) => props.theme.borderRadius.control};
	background-color: white;
	z-index: 10;
	max-height: ${(props) => (props.isOpen ? '200px' : '0')};
	opacity: ${(props) => (props.isOpen ? '1' : '0')};
	visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
	border-color: ${(props) => (props.isOpen ? `#12539E` : `#adb5bd`)}; // 파란색 테두리
	transition: all 0.2s ease;
	overflow-y: auto;
`;

export const OptionItem = styled.li`
	padding: 8px 12px;
	cursor: pointer;
	font-size: 14px;

	&:hover {
		background-color: #f5f5f5;
	}
`;
